/** Session key when user opens a Siri / Shortcut link before sign-in. */
export const SOC_AI_PENDING_MESSAGE_KEY = 'soc_ai_pending_message';

/** Query params: ?socAi=book+cleaning  or  ?msg=track+my+orders&openAi=1 */
export const SOC_AI_QUERY_KEYS = ['socAi', 'soc_ai', 'msg'] as const;

export function readPendingAiMessage(): string | null {
  try {
    const raw = sessionStorage.getItem(SOC_AI_PENDING_MESSAGE_KEY);
    return raw?.trim() || null;
  } catch {
    return null;
  }
}

export function storePendingAiMessage(message: string): void {
  const trimmed = message.trim();
  if (!trimmed) return;
  try {
    sessionStorage.setItem(SOC_AI_PENDING_MESSAGE_KEY, trimmed);
  } catch {
    // ignore quota / private mode
  }
}

export function clearPendingAiMessage(): void {
  try {
    sessionStorage.removeItem(SOC_AI_PENDING_MESSAGE_KEY);
  } catch {
    // ignore
  }
}

export function parseSocAiMessageFromSearch(search: string): string | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  for (const key of SOC_AI_QUERY_KEYS) {
    const value = params.get(key)?.trim();
    if (value) return decodeURIComponent(value.replace(/\+/g, ' '));
  }
  if (params.get('openAi') === '1') {
    return 'book a service';
  }
  return null;
}

export function stripSocAiParamsFromSearch(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  for (const key of SOC_AI_QUERY_KEYS) params.delete(key);
  params.delete('openAi');
  const rest = params.toString();
  return rest ? `?${rest}` : '';
}

/** Build a URL for Apple Shortcuts / Siri — opens SOC AI with a pre-filled message. */
export function buildSocAiDeepLink(baseUrl: string, message: string, path = '/home'): string {
  const origin = baseUrl.replace(/\/$/, '');
  const safePath = path.startsWith('/') ? path : `/${path}`;
  const url = new URL(`${origin}${safePath}`);
  url.searchParams.set('socAi', message.trim());
  return url.toString();
}
